export const RewardTypes = {
	Medal: 1,
	Trophy: 2,
	Globe: 3,
};
